module.exports = __webpack_public_path__ + "static/media/male.30b6edbe.png";